import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { BadgeVariant, ButtonMode, IconPosition } from '@fcom/ui-components';
import { FragmentService, LoaderType } from '@fcom/common';
import { CmsArticle } from '@fcom/core-api/interfaces';

import { Category } from '../../api/models';
import { FinnairServiceItemWithUpsell } from '../../interfaces';

@Component({
  selector: 'fin-upsell-card',
  templateUrl: 'upsell-card.component.html',
  styleUrls: ['../../../dapi/assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellCardComponent implements OnInit {
  readonly IconPosition = IconPosition;
  readonly LoaderType = LoaderType;
  readonly ButtonMode = ButtonMode;
  readonly BadgeVariant = BadgeVariant;

  @Input()
  service: FinnairServiceItemWithUpsell;

  @Output()
  upsellClicked: EventEmitter<Category> = new EventEmitter<Category>();

  article$: Observable<CmsArticle>;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.article$ = this.fragmentService.getFragment(this.service.upsell.articleKey);
  }
}
